<script>
import {Button} from "@core/components/common";
import { BCard, BCardTitle, BFormInput, BAlert } from 'bootstrap-vue'

export default {
    props: {
        product: {
            type: Object,
        }
    },
    components: {
        BCard, BCardTitle, Button, BFormInput, BAlert
    },
    computed: {
        isVisible() {
            if (!this.product || !this.product.legislations) {
                return false;
            }

            const rohs = Object.values(this.product.legislations).find(l => l.key === 'rohs');
            return rohs && rohs.isApplicable;
        }
    },
    data() {
        return {
            exemption: null,
            timeout: null
        };
    },
    methods: {
        exemptionChange() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.emit();
            }, 500);
        },
        emit() {
            this.$emit('change', {exemption: this.exemption ? this.exemption : null});
        }
    },
    watch: {
        product() {
            if (this.product.legislations) {
                const rohs = Object.values(this.product.legislations).find(l => l.key === 'rohs');
                this.exemption = rohs ? rohs.settings.exemption : '';
            }
        }
    }
}
</script>

<template>
    <b-card no-body border-variant="light" v-if="isVisible">
        <div class="card-header">
            <div class="col-md-6 pl-0">
                <b-card-title>{{ $t('Component(ProductLegislationRohs):title') }}</b-card-title>
            </div>
        </div>
        <div class="ml-2 mr-2 mb-2">
            <b-alert
                variant="light"
                show
            >
                <div class="alert-body">
                    {{ $t('Component(ProductLegislationRohs):instruction') }}
                </div>
            </b-alert>
            <b-form-input
                v-model="exemption"
                :placeholder="$t('Component(Placeholder):type-here')"
                @input="exemptionChange"
            />
        </div>
    </b-card>
</template>
